module.exports = __webpack_public_path__ + "static/media/Configuración_UMI.675eb0e3.svg";